import {Component, Injector} from '@angular/core';
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";

@Component({
    selector: 'app-units',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class UnitsComponent extends GeneralListComponent {


  constructor(injector: Injector) {
    super(injector);

    this.title = 'Units';
    this.showNewBtn = true;

    this.columns = [
      {id: 'name',label: 'Név', type: ColumnType.Simple},
      {id: 'modified',label: 'Módosítva', type: ColumnType.Simple},
      {id: 'modifiedBy',label: 'Módosította', type: ColumnType.Simple},
      {id: 'action', label: 'edit', type: ColumnType.Action}
    ];

  }

  fetchItems() {
    this.service.getUnits().subscribe((resp:any) => {
      this.handleFetchResponse(resp)
    })
  }

}
